function normalizeString(value) {
    return typeof value === 'string' ? value.trim() : '';
}

function parseRoleplayPreviewCharacters(value) {
    let characters = value;

    if (typeof characters === 'string') {
        try {
            characters = JSON.parse(characters);
        } catch (error) {
            return [];
        }
    }

    if (!Array.isArray(characters)) {
        return [];
    }

    const seen = new Set();

    return characters.reduce((normalized, character) => {
        if (!character || typeof character !== 'object') {
            return normalized;
        }

        const title = normalizeString(character.title);
        if (!title) {
            return normalized;
        }

        const slug = normalizeString(character.slug);
        const identity = slug || normalizeString(character.url) || title.toLowerCase();
        if (seen.has(identity)) {
            return normalized;
        }
        seen.add(identity);

        normalized.push({
            slug,
            title,
            subtitle: normalizeString(character.subtitle),
            image: normalizeString(character.image),
            url: normalizeString(character.url),
        });

        return normalized;
    }, []);
}

module.exports = { parseRoleplayPreviewCharacters };
